import React, { useState } from 'react'
import style from './Navbar.module.scss'
import { FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
    const { i18n, t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        document.dir = lng === 'ar' ? 'rtl' : 'ltr';
        setIsOpen(false);
    };

    return (
        <div className={`${style.navbar}`}>
            <div className="container">
                <div className={`${style.content}`}>
                    <div className={`${style.img}`}>
                        <a href="#">
                            <img src="images/logo.png" alt={t('navbar.logo')} />
                        </a>
                    </div>

                    <div className={`${style.listItems}`}>
                        <a href="#" className="nav-link">
                            <span>{t('navbar.home')}</span>
                        </a>
                        <a href="#about" className="nav-link">
                            <span>{t('navbar.about')}</span>
                        </a>
                        <a href="#services" className="nav-link">
                            <span>{t('navbar.services')}</span>
                        </a>
                        <a href="#product" className="nav-link">
                            <span>{t('navbar.products')}</span>
                        </a>
                        <a href="#contact" className="nav-link">
                            <span>{t('navbar.contact')}</span>
                        </a>
                        <div className={`${style.languageSwitcher}`}>
                            <button className={`${style.globeButton}`} onClick={() => setIsOpen(!isOpen)}>
                                <FaGlobe />
                            </button>
                            {isOpen && (
                                <div className={`${style.languageDropdown}`}>
                                    <button onClick={() => changeLanguage('en')}>
                                        {t('navbar.languages.english')}
                                    </button>
                                    <button onClick={() => changeLanguage('ar')}>
                                        {t('navbar.languages.arabic')}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
